import { render, staticRenderFns } from "./CreateGeneral.vue?vue&type=template&id=c217677c&"
import script from "./CreateGeneral.vue?vue&type=script&lang=js&"
export * from "./CreateGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports